import template from './asset-maintenance.component.html';
import * as AssetDetailsActions from '../../../../state/asset-details/asset-details.actions';

class AssetMaintenanceController {
  constructor(MaintenanceService, $ngRedux, $stateParams, gettext) {
    'ngInject';
    this.MaintenanceService = MaintenanceService;
    this.store = $ngRedux;
    this.$stateParams = $stateParams;
    this.gettext = gettext;

    this.activePlans = [];
    this.history = [];

    //paging
    this.itemsPerPage = 3;
    this.currentPage = {};
    this.currentPage.history = 1;
    this.currentPage.status = 1;
    this.maxSize = 1;
  }
  $onInit() {
    this.unsubscribe = this.store.connect(() => ({}), {...AssetDetailsActions})(this);
    this.getMaintenanceHistory();
  }
  $onChanges(changes) {
    const {asset} = changes;
    const {maintenancePlans = []} = asset.currentValue;
    this.activePlans = maintenancePlans;
  }
  $onDestroy() {
    this.unsubscribe();
  }
  completeMaintenancePlan(activePlane) {
    let equipmentData = {
      data: {
        id: this.asset.id,
        attributes: {name: this.asset.name}
      }
    };

    let planData = {
      id: activePlane.id,
      attributes: {name: activePlane.name}
    };
    this.MaintenanceService.showPopupForEquipmentPlan(equipmentData.data, planData)
      .result.then(() => {
        this.getAssetData(this.asset.id);
      })
      .catch(() => {});
  }
  getMaintenanceHistory() {
    this.loadingHistory = true;
    this.MaintenanceService.getHistory(null, [this.$stateParams.equipmentId])
      .then(
        response => {
          //show user text for the history instead of true/false
          const data = response.data || [];
          data.forEach(item => {
            item.completed = item.completed ? this.gettext('Completed') : this.gettext('Incomplete');
          });
          this.history = data;
        },
        () => {
          this.error = this.gettext('An error occurred while retrieving maintenance history for this asset.');
        }
      )
      .finally(() => {
        this.loadingHistory = false;
      });
  }
}

export default {
  template,
  controller: AssetMaintenanceController,
  //not using vm , when using ui-route it is conflicting with parent vm
  //https://github.com/johnpapa/angular-styleguide/issues/577#issue-115275989
  controllerAs: 'maintnanceVm',
  bindings: {
    loading: '<',
    refreshing: '<',
    asset: '<'
  }
};
